export default __webpack_public_path__ + "static/media/InnerTune2.5197a33f.png";